<template>
  <!-- The end of a call in Workspace369: the call card on the client's conversation
       (lib/view/inbox/widgets/thread/call_message_card.dart: "Call ended", the recording player,
       the AI "Call summary" card with "Powered by AI" and "Next steps", "Add note...") and the
       banner shown for about 12 seconds after a call (widgets/call/call_ended_banner.dart:
       "Call with … ended · 6:41 · View summary →"). The caller and the summary are sample data.
       Inside a StoryScene the banner slides in, then the summary and its next steps appear;
       resting styles are the final frame. -->
  <div class="pcw" aria-hidden="true">
    <header class="pcw-head">
      <span><b>Maya Ortiz</b><small>+1 (512) 555-0182</small></span>
      <span class="pcw-btn"><svg viewBox="0 0 24 24"><path :d="icons.phone" /></svg>Call</span>
    </header>
    <div class="pcw-body">
      <p class="pcw-divider"><svg viewBox="0 0 24 24"><path :d="icons.phone" /></svg>Call</p>
      <div class="pcw-call pcw-in" style="--d: 0.2s">
        <div class="pcw-call-head">
          <span class="pcw-call-icon"><svg viewBox="0 0 24 24"><path :d="icons.callback" /></svg></span>
          <b>Call ended</b>
          <small>6:41 · 10:12</small>
        </div>
        <div class="pcw-player">
          <span class="pcw-play"><svg viewBox="0 0 24 24"><path :d="icons.play" /></svg></span>
          <span class="pcw-wave"><i v-for="n in 28" :key="n" :style="{ '--h': `${wave[n % wave.length]}px` }" /></span>
          <small>6:41</small>
        </div>
        <div class="pcw-summary pcw-in" style="--d: 1.3s">
          <div class="pcw-summary-head">
            <span><svg viewBox="0 0 24 24"><path :d="icons.sparkle" /></svg>Call summary</span>
            <small>Powered by AI</small>
          </div>
          <p>Maya wants to move the product shoot to Thursday, Oct 29 and add a second set for the spring catalog.</p>
          <b class="pcw-next">Next steps</b>
          <ul>
            <li class="pcw-in" style="--d: 2s">Confirm the studio for Oct 29 at 10:00</li>
            <li class="pcw-in" style="--d: 2.4s">Send an updated proposal with the second set</li>
          </ul>
        </div>
        <div class="pcw-note"><svg viewBox="0 0 24 24"><path :d="icons.note" /></svg>Add note...</div>
      </div>
    </div>
    <div class="pcw-toast pcw-in" style="--d: 0.6s">
      <svg viewBox="0 0 24 24"><path :d="icons.end" /></svg>
      <span>Call with Maya Ortiz ended · <b>6:41</b> · <em>View summary →</em></span>
    </div>
  </div>
</template>

<script setup>
const wave = [6, 10, 14, 9, 18, 12, 7, 15, 20, 11, 8, 13];
const icons = {
  phone: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z",
  callback: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1L8.7 3.99c-.11-.35-.48-.6-.88-.6H4.33C3.6 3.39 3 3.99 3 4.72 3 15.27 11.73 24 22.28 24c.73 0 1.33-.6 1.33-1.33v-3.47c0-.4-.25-.77-.6-.88zM18 3v-.5h-2V3h-.5v2H18V3zm1-2h-5v6h5V1z",
  play: "M8 5v14l11-7z",
  sparkle: "M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z",
  note: "M19 3H4.99C3.89 3 3 3.9 3 5l.01 14c0 1.1.89 2 1.99 2h10l6-6V5c0-1.1-.9-2-2-2zM7 8h10v2H7V8zm5 6H7v-2h5v2zm2 5.5V14h5.5L14 19.5z",
  end: "M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08a.956.956 0 0 1-.29-.7c0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28a11.27 11.27 0 0 0-2.67-1.85.996.996 0 0 1-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z",
};
</script>

<style>
.pcw {
  --pcw-page: #fff;
  --pcw-wash: #f4f6f8;
  --pcw-card: #fff;
  --pcw-line: rgb(0 0 0 / 0.1);
  --pcw-text: #171717;
  --pcw-muted: #5f6368;
  --pcw-ai: #f3f0fd;
  --pcw-ai-line: #ddd3f7;
  --pcw-ai-ink: #5b3fb0;
  --pcw-inverse: #1f2937;
  --pcw-inverse-text: #f8fafc;
  --pcw-link: #67e8f9;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  border: 1px solid var(--pcw-line);
  border-radius: 10px;
  background: var(--pcw-page);
  color: var(--pcw-text);
  font-family: "Space Grotesk", Inter, ui-sans-serif, system-ui, sans-serif;
  font-size: 13px;
  line-height: 1.4;
  text-align: left;
  box-shadow: 0 18px 50px -18px rgb(15 23 42 / 0.28), 0 2px 6px rgb(15 23 42 / 0.06);
}
.dark .pcw {
  --pcw-page: #1c1c1c;
  --pcw-wash: #242424;
  --pcw-card: #262626;
  --pcw-line: rgb(255 255 255 / 0.13);
  --pcw-text: #ececec;
  --pcw-muted: #a8a8a8;
  --pcw-ai: rgb(121 72 175 / 0.18);
  --pcw-ai-line: rgb(160 110 220 / 0.35);
  --pcw-ai-ink: #d2b6f2;
  --pcw-inverse: #f1f5f9;
  --pcw-inverse-text: #0f172a;
  --pcw-link: #0e7490;
  box-shadow: 0 18px 50px -18px rgb(0 0 0 / 0.7);
}
.pcw svg { width: 14px; height: 14px; flex: none; fill: currentColor; }
.pcw-head { flex: none; display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid var(--pcw-line); padding: 10px 14px; }
.pcw-head > span:first-child { display: grid; line-height: 1.25; }
.pcw-head b { font-size: 14px; font-weight: 600; }
.pcw-head small { color: var(--pcw-muted); font-size: 11px; }
.pcw-btn { display: inline-flex; align-items: center; gap: 4px; border: 1px solid var(--pcw-line); border-radius: 6px; padding: 3px 8px; font-size: 12px; }
.pcw-body { display: grid; flex: 1; align-content: start; gap: 8px; min-height: 0; overflow: hidden; background: var(--pcw-wash); padding: 10px 14px 56px; }
.pcw-divider { display: flex; align-items: center; justify-content: center; gap: 5px; margin: 0; color: #7a3fb0; font-size: 11px; }
.dark .pcw-divider { color: #d2b6f2; }
.pcw-call { display: grid; gap: 8px; border: 1px solid var(--pcw-line); border-radius: 10px; background: var(--pcw-card); padding: 10px 12px; }
.pcw-call-head { display: flex; align-items: center; gap: 7px; }
.pcw-call-head b { font-weight: 600; }
.pcw-call-head small { margin-left: auto; color: var(--pcw-muted); font-size: 11.5px; }
.pcw-call-icon { display: grid; place-items: center; width: 24px; height: 24px; border-radius: 6px; background: var(--pcw-wash); color: #2d7a4e; }
.dark .pcw-call-icon { color: #6ed39a; }
.pcw-player { display: flex; align-items: center; gap: 8px; border-radius: 8px; background: var(--pcw-wash); padding: 6px 8px; }
.pcw-play { display: grid; place-items: center; width: 24px; height: 24px; border-radius: 6px; background: var(--pcw-text); color: var(--pcw-page); }
.pcw-wave { display: flex; flex: 1; align-items: center; gap: 2px; min-width: 0; height: 22px; overflow: hidden; }
.pcw-wave i { flex: none; width: 3px; height: var(--h); border-radius: 1px; background: var(--pcw-muted); opacity: 0.55; }
.pcw-player small { color: var(--pcw-muted); font-size: 11px; font-variant-numeric: tabular-nums; }
.pcw-summary { display: grid; gap: 4px; border: 1px solid var(--pcw-ai-line); border-radius: 10px; background: var(--pcw-ai); padding: 9px 11px; }
.pcw-summary-head { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.pcw-summary-head span { display: inline-flex; align-items: center; gap: 5px; color: var(--pcw-ai-ink); font-weight: 600; }
.pcw-summary-head small { color: var(--pcw-muted); font-size: 10.5px; }
.pcw-summary p { margin: 0; font-size: 12.5px; }
.pcw-next { margin-top: 2px; font-size: 12px; font-weight: 600; }
.pcw-summary ul { display: grid; gap: 2px; margin: 0; padding-left: 16px; list-style: disc; font-size: 12.5px; }
.pcw-note { display: flex; align-items: center; gap: 6px; border-radius: 8px; background: var(--pcw-wash); padding: 6px 9px; color: var(--pcw-muted); font-size: 12px; }
.pcw-toast { position: absolute; right: 12px; bottom: 12px; left: 12px; display: flex; align-items: center; gap: 9px; border-radius: 10px; background: var(--pcw-inverse); padding: 9px 12px; color: var(--pcw-inverse-text); font-size: 12.5px; box-shadow: 0 10px 24px -10px rgb(0 0 0 / 0.5); }
.pcw-toast svg { width: 17px; height: 17px; opacity: 0.85; }
.pcw-toast span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pcw-toast b { font-weight: 600; }
.pcw-toast em { color: var(--pcw-link); font-style: normal; font-weight: 600; }

.is-run .pcw-in { animation: pcw-in 0.5s cubic-bezier(0.33, 1, 0.68, 1) var(--d) both; }
.is-run .pcw-toast { animation: pcw-toast 0.5s cubic-bezier(0.33, 1, 0.68, 1) var(--d) both; }
@keyframes pcw-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: none; } }
@keyframes pcw-toast { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: none; } }
@media (max-width: 480px) {
  .pcw-body { padding: 8px 10px 56px; }
  .pcw-toast { right: 8px; left: 8px; }
  /* Phones wrap the banner so "View summary →" stays in view. */
  .pcw-toast span { white-space: normal; }
}
</style>
